export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">关于我们</h2>
          <p className="text-sm text-foreground-500">了解51每日大赛背后的故事</p>
        </div>

        <div className="bg-background-100 rounded-lg p-6 md:p-10">
          <div className="max-w-2xl mx-auto text-center">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-4">
              51每日大赛诞生于2023年，由一群热爱追踪娱乐八卦的资深吃瓜群众创立。我们厌倦了各大平台信息碎片化、真假难辨的吃瓜体验，决心打造一个专业、可信、高效的娱乐爆料聚合平台。
            </p>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
              平台坚持<strong>多源验证、快速响应、保护信源</strong>三大原则，每条爆料都经过编辑团队严格把关。我们相信，吃瓜也可以有态度、有底线、有温度。截至目前，平台已累计发布爆料内容超过<strong className="text-primary-600">15,000条</strong>，服务超过<strong className="text-primary-600">500万月活跃用户</strong>。
            </p>
            <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-team-line text-primary-500"></i>
                专业编辑团队
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line text-primary-500"></i>
                7×24小时更新
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-shield-check-line text-primary-500"></i>
                多源交叉验证
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-lock-line text-primary-500"></i>
                匿名投稿保护
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}